import { Component, OnInit } from '@angular/core';
import { ViewManagerService } from '../../services/view-manager-service';
import { UrlSettingsCore } from '../../configuration/url-settings-core';

declare var backHome: any;
declare var closeModalbyClass: any;

@Component({
    selector: 'main [error-page]',
  templateUrl: 'error-page.component.html',
  host: {'[attr.id]': '\'content\'' },
})

export class ErrorPageComponent implements OnInit {
  message: any = 'Sessione Scaduta!';
  messageViewManager: any;
  urlWelcomeBoard: string = UrlSettingsCore.URL_VISUALIZZA_WELCOME_BOARD;
  constructor(private viewManager: ViewManagerService) {
    this.viewManager.hideMenu();
    this.viewManager.hideNotifiche();
    this.messageViewManager = this.viewManager.errorMsg;
  }

  ngOnInit() {
    closeModalbyClass('fade.in');
  }

  redirectHome() {
    backHome();
  }

}
